import { Component } from '@angular/core';

@Component({
  selector: 'ow-hotline-cta',
  templateUrl: './hotline-cta.component.html'
})
export class HotlineCtaComponent {

}
